export enum ReportColumnType {
	String = 0,
	Number = 1,
	DateTime = 2,
	DateOnly = 3,
	Currency = 4,
	Boolean = 5,
	Tags = 6,
	// A UTC instant displayed as a date only, converted to the user's selected timezone.
	ZonedDate = 7
}
